<template>
  <!-- 增加修改 -->
  <a-drawer :maskClosable="false" width="70%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <CreateFound :userId="userId"></CreateFound>
  </a-drawer>
</template>

<script>
import CreateFound from '../../../pressure/fund/index.vue'
export default {
  name: 'CreateForm',
  components: { CreateFound },
  data() {
    return {
      userId: '',
      replaceFields: { children: 'children', title: 'label', key: 'id', value: 'id' },
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      // 默认密码
      initPassword: undefined,
      formTitle: '',
      rolesId: [],
      isFage: false,
      isEdit: false,
      // 表单参数
      form: {
        id: undefined,
        deptId: 0,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        sex: 0,
        status: 1,
        remark: undefined,
        postIds: [],
        roleIds: [],
        cardImgs: [],
        avatar: undefined,
        birthday: undefined,
      },
      open: false,
      userRegion: [],
      rules: {
        // regionId: [{ required: true, message: '请选择区域', trigger: 'blur' }],
        userName: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
        nickName: [{ required: true, message: '用户姓名不能为空', trigger: 'blur' }],
        // deptId: [{ required: true, message: '部门不能为空', trigger: 'change' }],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { min: 5, max: 20, message: '用户密码长度必须介于 5 和 20 之间', trigger: 'blur' },
        ],
        // email: [
        //   { required: true, message: '邮箱不能为空', trigger: 'blur' },
        //   {
        //     type: 'email',
        //     message: '请正确填写邮箱地址',
        //     trigger: ['blur', 'change'],
        //   },
        // ],
        phoneNumber: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  filters: {},
  created() {
    // this.deptOption = this.deptOptions
    console.log(this.deptOptions, 'this.deptOptions')

    // this.getConfigKey('sys.user.initPassword').then((response) => {
    //   this.initPassword = response.msg
    //   console.log(response.msg,' response.msg')
    // })
    if (this.role) {
      pageRole({ roleKey: this.role }).then((res) => {
        console.log(res, '测试角色细心')
        if (res.data.records.length) {
          this.rolesId = [res.data.records[0].id]
        }
      })
    }
    console.log(this.role, '测试角色====')
    if (this.userType === 1 || this.userType === 0) {
      this.getQu()
    }
  },
  watch: {},
  methods: {
    onClose() {
      let that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() { },
      })
    },
    // 点击角色发生变化
    handleRoleChange(e) { },
    // 点击添加区域
    handleQu() {
      this.childrenDrawer = true
      this.$nextTick(() => {
        this.$refs.ReginForm.handleAdd()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
      deptTreeSelect().then((response) => {
        this.deptOptions = response.data
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        deptId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        email: undefined,
        sex: 0,
        status: 1,
        remark: undefined,
        postIds: [],
        roleIds: [],
        cardImgs: [],
        avatar: undefined,
        birthday: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.isEdit = false
      this.reset()
      this.$emit('select-tree')
      this.open = true
      this.formTitle = '新增用户'
      this.form.password = this.initPassword
      this.isFage = true
      this.isShow = false
      this.getuserInfo()
    },
    // 查询用户信息
    getuserInfo() {
      getUser(this.userId ? this.userId : '').then((response) => {
        console.log(response, 'responseresponseresponse=======')
        this.postOptions = response.data.posts
        this.roleOptions = response.data.roles
      })
    },
    // 手机号发生变化
    handleChangePhone() {
      // if (!this.role) return
      const phoneNumber = this.form.phoneNumber
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (phoneNumber && phoneNumber.length === 11) {
        if (!reg.test(phoneNumber)) return this.$message.error('请输入正确的手机号')
        checkPhone({ phoneNumber: this.form.phoneNumber }).then((res) => {
          console.log(res, '的点点滴滴')
          if (Number(res.data.unique) === 1) {
            const phone = this.form.phoneNumber
            this.form = res.data
            this.form.phoneNumber = phone
            this.isShow = true
            this.isFage = true
          } else {
            // this.get
            this.isShow = true
            this.isFage = false
            this.reset()
            this.form.phoneNumber = phoneNumber
            this.$forceUpdate()
          }
          //   if(res.unique==1){
          // 	this.show=false
          // 	this.id=res.id
          // }else{
          // 	this.show=true
          // }
        })
      }
    },
    // 选择生日
    handleChange(date, dateString) {
      console.log(date, dateString, '的点点滴滴')
      this.form.birthday = dateString
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      console.log(row, 'rowrow');
      this.userId = row.id
      // this.reset()
      // this.$emit('select-tree')
      // const userId = row ? row.id : ids
      this.formTitle = '资金账户'
      this.open = true
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.isFage, 'isFageisFage')
      let that = this
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.role) {
            this.form.roleIds = this.rolesId
          }
          if (this.isFage) {
            userBd(that.form)
              .then((respon) => {
                that.$message.success('绑定成功', 3)
                that.open = false
                that.$emit('ok')
              })
              .finally(() => {
                that.submitLoading = false
              })
          } else {
            if (this.form.id !== undefined) {
              updateUser(this.form)
                .then((response) => {
                  this.$message.success('修改成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            } else {
              this.form.userName = this.form.phoneNumber
              addUser(this.form)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            }
          }
          // checkPhone({ phoneNumber: this.form.phoneNumber }).then((res) => {
          //   console.log(res, '的点点滴滴')
          //   res = res.data
          //   if (Number(res.unique) === 1) {
          //     that.form.id = res.id
          //   } else {

          //   }
          // })
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.form_select {
  display: flex;
  align-items: center;

  .ant-select {
    width: 300px;
    margin-right: 20px;
  }
}
</style>
